import { useState, useEffect } from 'react';
import { Icon } from './Icons.jsx';
import { MobHeader, FooterBar } from './Stepper.jsx';

export default function Step3Location({ state, setState, onNext, onBack }) {
  const [search, setSearch] = useState(state.location || { cep: '', neighborhood: '', city: '' });
  const [cepError, setCepError] = useState(null);
  const [looking, setLooking] = useState(false);

  const cepDigits = (search.cep || '').replace(/\D/g, '');
  const cepValid = cepDigits.length === 8;

  // Consulta o endereço real do CEP (ViaCEP)
  useEffect(() => {
    if (!cepValid) { setCepError(null); return; }
    setLooking(true);
    fetch(`https://viacep.com.br/ws/${cepDigits}/json/`)
      .then(r => r.json())
      .then(data => {
        if (data.erro) {
          setCepError('CEP não encontrado.');
          setSearch(s => ({ ...s, neighborhood: '', city: '' }));
        } else {
          setCepError(null);
          setSearch(s => ({ ...s, neighborhood: data.bairro || '', city: data.localidade || '' }));
        }
      })
      .catch(() => setCepError(null)) // sem rede para o ViaCEP não bloqueia o fluxo
      .finally(() => setLooking(false));
  }, [cepDigits, cepValid]);

  const run = () => {
    if (!cepValid) return;
    setState(s => ({ ...s, location: search }));
    onNext();
  };

  return (
    <>
      <MobHeader title="Onde realizar" onBack={onBack}/>
      <div style={{ flex: 1, minHeight: 0, padding: '18px 16px', overflowY: 'auto', background: 'var(--bg)' }}>
        <h2 style={{ fontSize: 20, fontWeight: 700 }}>Onde você quer realizar?</h2>
        <p style={{ color: 'var(--text-muted)', marginTop: 4, fontSize: 14 }}>Buscamos laboratórios próximos.</p>

        <div className="card" style={{ padding: 14, marginTop: 16 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <div>
              <label className="input-label">CEP</label>
              <input
                className="input"
                value={search.cep}
                onChange={e => setSearch({ ...search, cep: e.target.value })}
                placeholder="00000-000"
                inputMode="numeric"
              />
              {cepError && <div style={{ fontSize: 12, color: 'var(--brand-primary)', marginTop: 4 }}>{cepError}</div>}
            </div>
            {(search.neighborhood || search.city) && (
              <div>
                <label className="input-label">Endereço</label>
                <input className="input" value={[search.neighborhood, search.city].filter(Boolean).join(', ')} readOnly style={{ background: 'var(--marble-soft)' }}/>
              </div>
            )}
          </div>

          <button className="btn btn-primary" onClick={run} style={{ marginTop: 14 }} disabled={!cepValid || looking}>
            <Icon.search size={16} color="var(--white)"/> {looking ? 'Consultando CEP…' : 'Buscar laboratórios'}
          </button>
        </div>
      </div>
      <FooterBar onBack={onBack} onNext={run} canNext={cepValid} hint={!cepValid ? 'Informe um CEP válido para continuar' : null}/>
    </>
  );
}
